import { gql } from '@apollo/client';

export const PAGINATE_REPORTS = gql`
	query PaginateReports(
		$first: Int! = 30
		$page: Int! = 1
		$search: String
	) {
		paginateReports(
			first: $first
			page: $page
			search: $search
		) {
			paginatorInfo {
                count
                currentPage
                firstItem
                perPage
                lastItem
                total
            }
            data { 
                id
                user_id
                name
                url
                status
                created_at
            }
		}
	}
`;

export const LIST_LAST_REPORTS = gql`
	query ListLastReports {
		listLastReports {
            id
            user_id
            name
            url
            status
            created_at
        }
	}
`;

export const CREATE_REPORT = gql`
	mutation CreateReport($name: String) {
		createReport(name: $name) {
            id
            user_id
            name
            url
            status
            created_at
        }
	}
`;

export const GET_REPORT_URL = gql`
    query GetReportUrl($path: String!) {
        getReportUrl(path: $path)
    }
`;

export const GET_MONTHLY_REPORT = gql`
    query GetMonthlyReport {
        getMonthlyReport {
            filename
            content
        }
    }
`;